// extracted by mini-css-extract-plugin
module.exports = {"loadingSkeleton":"animations_loadingSkeleton__TkhRO","skeleton-loading":"animations_skeleton-loading__NmxqE"};